import hoverintent from "hoverintent";

class Navigation {
  constructor() {
    this.dropdownLinks = null;

    this.getElements();
    this.init();
  }

  getElements() {
    this.dropdownLinks = document.querySelectorAll('.nav-item');
  }

  init() {
    this.handleIntent();
  }

  handleIntent() {
    if (this.dropdownLinks.length > 0) {

      this.dropdownLinks.forEach((link) => {
        hoverintent(link, (e) => {
          link.classList.add('has-intent');
        }, (e) => {
          link.classList.remove('has-intent');
        }).options({
          timeout: 500,
          handleFocus: true
        });
      });
    }
  }
}

export const navigation = () => {
  new Navigation(); // eslint-disable-line no-new
};
